import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div {{this.setup}}>\n	{{yield}}\n</div>\n")